<template>
    <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
        <!-- Content Header (Page header) -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="/home">Home</a></li>
                            <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
                        </ol>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content" v-if="usertype == 'zonal-manager' || usertype == 'mis-admin' || usertype == 'secondary-mis-admin' || usertype == 'purchase-admin' || usertype == 'purchase-manager'">
            <br>
            <!-- main row for all icons  -->
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-6">


                    </div>
                    <div class="col-md-6">

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3" style="padding: 1% !important; background: white; border-radius: 30px !important;">
                        <div class="row">
                            <address class="m-t-5 m-b-5" style="margin-left: 10px !important;">
                                <p><b>ST_ID:</b></p>
                                <h5>{{stocktransfer.id}}</h5>
                                <p><b>Document Date:</b></p>
                                <h5>{{document_date| timeStamp}}</h5>
                                <p><b>Document Status:</b></p>
                                <h4><span class="right badge badge-secondary">{{stocktransfer.status}}</span></h4>
                                <p><b>Document Item Count: &nbsp;</b></p>
                                <h2><span class="right badge badge-warning">{{total_scanned_items}} Item(s)</span></h2>
                            </address>
                        </div>
                    </div>
                    &nbsp; &nbsp;
                    <div class="col-md-3" style="padding: 1% !important; background: cornsilk; border-radius: 30px !important;">
                        <div class="row">
                            <address class="m-t-5 m-b-5" style="margin-left: 10px !important;">
                                <h5>Origin: (Item Going From)</h5>
                                <strong class="text-inverse">{{ stocktransfer.request_origin_branch.branch }} - {{ stocktransfer.request_origin_branch.branch_code }}</strong
                                ><br />
                                {{ stocktransfer.request_origin_branch.address_line_1 }}<br />
                                {{ stocktransfer.request_origin_branch.address_line_2 }}<br />
                                {{ stocktransfer.request_origin_branch.address_line_3 }}<br />
                                <br />
                                {{ stocktransfer.request_origin_branch.city }} {{ stocktransfer.request_origin_branch.pincode }},
                                {{ stocktransfer.request_origin_branch.state }}, {{ stocktransfer.request_origin_branch.country }}
                                <br />
                                Phone: {{stocktransfer.request_origin_branch.phone}}<br>
                                Email: {{ stocktransfer.request_origin_branch.email }}
                            </address>
                        </div>
                    </div>
                    &nbsp; &nbsp;
                    <!--                    <div class="col-md-1"><br></div>-->
                    <div class="col-md-3" style="padding: 1% !important; background: cornsilk; border-radius: 30px !important;">
                        <div class="row">
                            <address class="m-t-5 m-b-5" style="margin-left: 10px !important;">
                                <h5>Destination: (Item Coming to)</h5>
                                <strong class="text-inverse">{{ stocktransfer.request_destination_branch.branch }} - {{ stocktransfer.request_destination_branch.branch_code }}</strong
                                ><br />
                                {{ stocktransfer.request_destination_branch.address_line_1 }}<br />
                                {{ stocktransfer.request_destination_branch.address_line_2 }}<br />
                                {{ stocktransfer.request_destination_branch.address_line_3 }}<br />
                                <br />
                                {{ stocktransfer.request_destination_branch.city }} {{ stocktransfer.request_destination_branch.pincode }},
                                {{ stocktransfer.request_destination_branch.state }}, {{ stocktransfer.request_destination_branch.country }}
                                <br />
                                Phone: {{stocktransfer.request_destination_branch.phone}}<br>
                                Email: {{ stocktransfer.request_destination_branch.email }}
                            </address>
                        </div>
                    </div>
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    <div class="col-md-2 justify-content-center" style="padding: 1% !important;">
                        <div class="row">

                            <button style="width:100% !important; margin-top: 10% !important; margin-bottom: 10% !important; background: orange !important; border-color: none !important;" class="btn" @click="scanAnyItemsPrompt()"><i class="fa fa-eye"></i> Scan Serial/IMEI</button>

                            <br>

                            <button style="width:100% !important; margin-top: 10% !important; margin-bottom: 10% !important;" class="btn btn-secondary" @click="scanItemsPrompt(item,index)"><i class="fa fa-print"></i> Print Transfer Request</button>

                            <br>

                            <button v-if="stocktransfer.status!='Pending Branch Manager Approval'" style="width:100% !important; margin-top: 10% !important; margin-bottom: 10% !important;" class="btn btn-success" @click="printTransferDocument"><i class="fa fa-print"></i> Print Transfer Document</button>

                        </div>
                    </div>
                </div>
            </div>
            <br><br>
            <br><br>
            <div class="col-md-12">
                <div class="row">
                    <div class="card card-danger card-outline" style="width:100% !important;">
                        <div class="card-body">
                            <div class="row">
                                <table class="table thead-dark table-striped" style="width: 100%">
                                    <colgroup>
                                        <col span="1" style="width: 10%;">
                                        <col span="1" style="width: 30%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 10%;">
                                        <col span="1" style="width: 10%;">
                                        <col span="1" style="width: 10%;">
                                    </colgroup>
                                    <thead class="thead-dark">
                                    <th><b>Item Code</b></th>
                                    <th><b>Item Name</b></th>
                                    <th><b>Requested Quantity</b></th>
                                    <th><b>Approved Quantity</b></th>
                                    <th><b>Transferred Quantity</b></th>
                                    <th><b>Scanned Quantity</b></th>
                                    <th><b>Price</b></th>
                                    <th><b>Notes</b></th>
                                    <th><b>ZM Status</b></th>
                                    <th><i class="fa fa-cog"></i></th>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in stocktransfer.stock_transfer_request_details">
                                        <!--                                    <td>{{index}}</td>-->
                                        <td>
                                            <p>{{item.item_code}}</p>
                                            <p><button style="width:100% !important; background: orange !important; border-color: none !important;" class="btn" @click="scanItemsPrompt(item,index)"><i class="fa fa-eye"></i> Scan</button></p>
                                        </td>
                                        <td><p>{{item.item_name}}</p>
                                            <p>
                                            <div class="form-group">
                                                <label>Serial Numbers: </label>
                                                <span class="lead">
                                                <span v-if="stocktransfer.stock_transfer_request_details[index].stock_transfer_items.length>0" v-for="(sl, i) in item.stock_transfer_items" :key="i" class="badge badge-pill badge-dark">
                                                {{sl.transferred_imei}}
                                                <a style="cursor: pointer;" @click="removeSl(index,i)"><i class="fa fa-times" aria-hidden="true"></i></a>
                                                </span>
                                                </span>
                                            </div>
                                            </p>
                                            <!--                                        <div class="form-group">-->
                                            <!--                                            <label>Serial Numbers: </label>-->
                                            <!--                                            <span class="lead">-->
                                            <!--											<span v-if="stocktransfer.stock_transfer_request_details[index].stock_transfer_items.length<=item.transferred_quantity" v-for="(sl, i) in item.stock_transfer_items" :key="i" class="badge badge-pill badge-dark">-->
                                            <!--												{{sl.transferred_imei}}-->
                                            <!--												<a style="cursor: pointer;" @click="removeSl(index,i)"><i class="fa fa-times" aria-hidden="true"></i></a>-->
                                            <!--											</span>-->
                                            <!--										</span>-->
                                            <!--                                        </div>-->
                                            <!--                                        <div class="form-group">-->
                                            <!--                                            <input type="text" placeholder="Enter the serial number" v-model="sl_no">-->
                                            <!--                                        </div>-->
                                            <!--                                        <div class="form-group">-->
                                            <!--                                            <button class="btn btn-danger" @click="addWarehouseSerial(index, item.item_code)">Add</button>-->
                                            <!--                                        </div></td>-->
                                        <td style="padding-left: 3% !important;"><div class="row">
                                            <p>{{item.requested_quantity}}</p>
                                        </div></td>
                                        <td style="padding-left: 3% !important;"><div class="row">
                                            <p>{{item.approved_quantity}}</p>
                                        </div></td>
                                        <td><div class="row">
                                            <input style="width:80% !important;" class="form-control" type="number" v-model="item.transferred_quantity">
                                        </div></td>
                                        <td style="padding-left: 3% !important;"><div class="row">
                                            <b style="color: red !important;" v-if="item.stock_transfer_items?.length != item.transferred_quantity">{{item.stock_transfer_items?.length}}&nbsp;<span class="right badge badge-danger"><i class="fa fa-warning"></i></span></b>
                                            <b style="color: green !important;" v-if="item.stock_transfer_items?.length == item.transferred_quantity">{{item.stock_transfer_items?.length}}&nbsp;<span class="right badge badge-success"><i class="fa fa-check"></i></span></b>
                                        </div></td>
                                        <td><p>{{item.price}}</p></td>
                                        <td>{{item.notes}}</td>
                                        <td>{{item.status}}</td>
                                        <td>
                                            <button style="width:100% !important;" class="btn btn-success" @click="approveItemZM(index, 'APPROVED')" v-if="item.status == 'CREATED'">Approve</button>
                                            <br>
                                            <button style="width:100% !important;" class="btn btn-danger" @click="approveItemZM(index, 'REMOVED')" v-if="item.status == 'CREATED'">Reject</button>
                                            <!--                                        <p><button @click="deleteTransferItem(index)" class="btn btn-danger"><i class="fa fa-trash"></i></button></p>-->
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br><br>
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-6" v-if="stocktransfer.approved == true">
                        <span class="right badge badge-secondary">Notes:</span>
                        <input class="form-control" style="width:100% !important;" type="text" v-model="notes" placeholder="Enter notes" readonly>
                    </div>
                    <div class="col-md-6" v-if="stocktransfer.approved != true">
                        <span class="right badge badge-secondary">Notes:</span>
                        <input class="form-control" style="width:100% !important;" type="text" v-model="notes" placeholder="Enter notes">
                    </div>
                    <br><br>
                </div>
                <div class="row">
                    <div class="col-md-12" v-if="stocktransfer.approved !=true">
                        <button style="width:100% !important;"  class="btn btn-danger" @click="approveTransfer">Approve Stock Transfer</button>
                    </div>
                </div>
            </div>
            <br><br><br><br><br><br><br>


            <br>

        </section>

        <section class="content" v-if="usertype == 'branch-manager' || usertype == 'store-manager' || usertype == 'branch-accountant'">
            <br>
            <!-- main row for all icons  -->
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-6">


                    </div>
                    <div class="col-md-6">

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3" style="padding: 1% !important; background: white; border-radius: 30px !important;">
                        <div class="row">
                            <address class="m-t-5 m-b-5" style="margin-left: 10px !important;">
                                <p><b>ST_ID:</b></p>
                                <h5>{{stocktransfer.id}}</h5>
                                <p><b>Document Date:</b></p>
                                <h5>{{document_date| timeStamp}}</h5>
                                <p><b>Document Status:</b></p>
                                <h4><span class="right badge badge-secondary">{{stocktransfer.status}}</span></h4>
                                <p><b>Document Item Count: &nbsp;</b></p>
                                <h2><span class="right badge badge-warning">{{total_scanned_items}} Item(s)</span></h2>
                            </address>
                        </div>
                    </div>
                    &nbsp; &nbsp;
                    <div class="col-md-3" style="padding: 1% !important; background: cornsilk; border-radius: 30px !important;">
                        <div class="row">
                            <address class="m-t-5 m-b-5" style="margin-left: 10px !important;">
                                <h5>Origin: (Item Going From)</h5>
                                <strong class="text-inverse">{{ stocktransfer.request_origin_branch.branch }} - {{ stocktransfer.request_origin_branch.branch_code }}</strong
                                ><br />
                                {{ stocktransfer.request_origin_branch.address_line_1 }}<br />
                                {{ stocktransfer.request_origin_branch.address_line_2 }}<br />
                                {{ stocktransfer.request_origin_branch.address_line_3 }}<br />
                                <br />
                                {{ stocktransfer.request_origin_branch.city }} {{ stocktransfer.request_origin_branch.pincode }},
                                {{ stocktransfer.request_origin_branch.state }}, {{ stocktransfer.request_origin_branch.country }}
                                <br />
                                Phone: {{stocktransfer.request_origin_branch.phone}}<br>
                                Email: {{ stocktransfer.request_origin_branch.email }}
                            </address>
                        </div>
                    </div>
                    &nbsp; &nbsp;
                    <!--                    <div class="col-md-1"><br></div>-->
                    <div class="col-md-3" style="padding: 1% !important; background: cornsilk; border-radius: 30px !important;">
                        <div class="row">
                            <address class="m-t-5 m-b-5" style="margin-left: 10px !important;">
                                <h5>Destination: (Item Coming to)</h5>
                                <strong class="text-inverse">{{ stocktransfer.request_destination_branch.branch }} - {{ stocktransfer.request_destination_branch.branch_code }}</strong
                                ><br />
                                {{ stocktransfer.request_destination_branch.address_line_1 }}<br />
                                {{ stocktransfer.request_destination_branch.address_line_2 }}<br />
                                {{ stocktransfer.request_destination_branch.address_line_3 }}<br />
                                <br />
                                {{ stocktransfer.request_destination_branch.city }} {{ stocktransfer.request_destination_branch.pincode }},
                                {{ stocktransfer.request_destination_branch.state }}, {{ stocktransfer.request_destination_branch.country }}
                                <br />
                                Phone: {{stocktransfer.request_destination_branch.phone}}<br>
                                Email: {{ stocktransfer.request_destination_branch.email }}
                            </address>
                        </div>
                    </div>
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    <div class="col-md-2 justify-content-center" style="padding: 1% !important;">
                        <div class="row">

                            <button style="width:100% !important; margin-top: 10% !important; margin-bottom: 10% !important; background: orange !important; border-color: none !important;" class="btn" @click="scanAnyItemsPrompt()"><i class="fa fa-eye"></i> Scan Serial/IMEI</button>

                            <br>

                            <button style="width:100% !important; margin-top: 10% !important; margin-bottom: 10% !important;" class="btn btn-secondary" @click="scanItemsPrompt(item,index)"><i class="fa fa-print"></i> Print Transfer Request</button>

                            <br>

                            <button v-if="stocktransfer.status!='Pending Branch Manager Approval'" style="width:100% !important; margin-top: 10% !important; margin-bottom: 10% !important;" class="btn btn-success" @click="printTransferDocument"><i class="fa fa-print"></i> Print Transfer Document</button>

                        </div>
                    </div>
                </div>
            </div>
            <br><br>
            <br><br>
            <div class="col-md-12">
                <div class="row">
                    <div class="card card-danger card-outline" style="width:100% !important;">
                        <div class="card-body">
                            <div class="row">
                                <table class="table thead-dark table-striped" style="width: 100%">
                                    <colgroup>
                                        <col span="1" style="width: 10%;">
                                        <col span="1" style="width: 30%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 10%;">
                                        <col span="1" style="width: 10%;">
                                        <col span="1" style="width: 10%;">
                                    </colgroup>
                                    <thead class="thead-dark">
                                    <th><b>Item Code</b></th>
                                    <th><b>Item Name</b></th>
                                    <th><b>Requested Quantity</b></th>
                                    <th><b>Approved Quantity</b></th>
                                    <th><b>Transferred Quantity</b></th>
                                    <th><b>Scanned Quantity</b></th>
                                    <th><b>Price</b></th>
                                    <th><b>Notes</b></th>
                                    <th><b>ZM Status</b></th>
                                    <th><i class="fa fa-cog"></i></th>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in stocktransfer.stock_transfer_request_details">
                                        <!--                                    <td>{{index}}</td>-->
                                        <td>
                                            <p>{{item.item_code}}</p>
                                            <p><button style="width:100% !important; background: orange !important; border-color: none !important;" class="btn" @click="scanItemsPrompt(item,index)"><i class="fa fa-eye"></i> Scan</button></p>
                                        </td>
                                        <td><p>{{item.item_name}}</p>
                                            <p>
                                            <div class="form-group">
                                                <label>Serial Numbers: </label>
                                                <span class="lead">
                                                <span v-if="stocktransfer.stock_transfer_request_details[index].stock_transfer_items.length>0" v-for="(sl, i) in item.stock_transfer_items" :key="i" class="badge badge-pill badge-dark">
                                                {{sl.transferred_imei}}
                                                <a style="cursor: pointer;" @click="removeSl(index,i)"><i class="fa fa-times" aria-hidden="true"></i></a>
                                                </span>
                                                </span>
                                            </div>
                                            </p>
                                            <!--                                        <div class="form-group">-->
                                            <!--                                            <label>Serial Numbers: </label>-->
                                            <!--                                            <span class="lead">-->
                                            <!--											<span v-if="stocktransfer.stock_transfer_request_details[index].stock_transfer_items.length<=item.transferred_quantity" v-for="(sl, i) in item.stock_transfer_items" :key="i" class="badge badge-pill badge-dark">-->
                                            <!--												{{sl.transferred_imei}}-->
                                            <!--												<a style="cursor: pointer;" @click="removeSl(index,i)"><i class="fa fa-times" aria-hidden="true"></i></a>-->
                                            <!--											</span>-->
                                            <!--										</span>-->
                                            <!--                                        </div>-->
                                            <!--                                        <div class="form-group">-->
                                            <!--                                            <input type="text" placeholder="Enter the serial number" v-model="sl_no">-->
                                            <!--                                        </div>-->
                                            <!--                                        <div class="form-group">-->
                                            <!--                                            <button class="btn btn-danger" @click="addWarehouseSerial(index, item.item_code)">Add</button>-->
                                            <!--                                        </div></td>-->
                                        <td style="padding-left: 3% !important;"><div class="row">
                                            <p>{{item.requested_quantity}}</p>
                                        </div></td>
                                        <td style="padding-left: 3% !important;"><div class="row">
                                            <p>{{item.approved_quantity}}</p>
                                        </div></td>
                                        <td><div class="row">
                                            <input style="width:80% !important;" class="form-control" type="number" v-model="item.transferred_quantity">
                                        </div></td>
                                        <td style="padding-left: 3% !important;"><div class="row">
                                            <b style="color: red !important;" v-if="item.stock_transfer_items?.length != item.transferred_quantity">{{item.stock_transfer_items?.length}}&nbsp;<span class="right badge badge-danger"><i class="fa fa-warning"></i></span></b>
                                            <b style="color: green !important;" v-if="item.stock_transfer_items?.length == item.transferred_quantity">{{item.stock_transfer_items?.length}}&nbsp;<span class="right badge badge-success"><i class="fa fa-check"></i></span></b>
                                        </div></td>
                                        <td><p>{{item.price}}</p></td>
                                        <td>{{item.notes}}</td>
                                        <td>{{item.status}}</td>
                                        <td>
                                            <button style="width:100% !important;" class="btn btn-success" @click="approveItemBM(index, 'APPROVED')" v-if="(item.status == 'CREATED') && branch == stocktransfer.source_branch">Confirm</button>
                                            <br>
                                            <br>
                                            <button style="width:100% !important;" class="btn btn-danger" @click="approveItemBM(index, 'REMOVED')" v-if="(item.status == 'CREATED' || item.status == 'APPROVED') && branch == stocktransfer.source_branch">Reject</button>
                                            <!--                                        <p><button @click="deleteTransferItem(index)" class="btn btn-danger"><i class="fa fa-trash"></i></button></p>-->
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br><br>
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-6" v-if="stocktransfer.accepted == true">
                        <span class="right badge badge-secondary">Notes:</span>
                        <input class="form-control" style="width:100% !important;" type="text" v-model="notes" placeholder="Enter notes" readonly>
                    </div>
                    <div class="col-md-6" v-if="stocktransfer.accepted != true">
                        <span class="right badge badge-secondary">Notes:</span>
                        <input class="form-control" style="width:100% !important;" type="text" v-model="notes" placeholder="Enter notes">
                    </div>
                    <br><br>
                    <br>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button style="width:100% !important;" class="btn btn-danger" @click="completeTransfer" v-if="stocktransfer.status == 'Pending Branch Manager Approval' && branch == stocktransfer.source_branch">Complete Stock Transfer</button>
                    </div>
                    <div class="col-md-12">
                        <button style="width:100% !important;" class="btn btn-danger" @click="completeTransfer" v-if="stocktransfer.status == 'Zonal Manager Approved' && branch == stocktransfer.source_branch">Complete Stock Transfer</button>
                    </div>
                    <div class="col-md-12">
                        <button style="width:100% !important;" class="btn btn-danger" @click="completeTransfer" v-if="stocktransfer.status == 'Branch Manager Approved' && branch == stocktransfer.source_branch">Complete Stock Transfer</button>
                    </div>
                    <div class="col-md-12">
                        <button style="width:100% !important;" class="btn btn-danger" @click="receivedTransfer" v-if="stocktransfer.status == 'In Transit' && branch == stocktransfer.destination_branch">Received Stock Transfer</button>
                    </div>
                    <div class="col-md-12">
                        <button style="width:100% !important;" class="btn btn-secondary" @click="ewayBillPrompt" v-if="stocktransfer.status == 'In Transit' && branch == stocktransfer.source_branch">Generate E Way Bill</button>
                    </div>
                </div>
            </div>
            <br><br><br><br><br><br><br>
        </section>




        <section class="content" v-if="usertype == 'warehouse-manager'">
            <br>
            <!-- main row for all icons  -->
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-6">


                    </div>
                    <div class="col-md-6">

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3" style="padding: 1% !important; background: white; border-radius: 30px !important;">
                        <div class="row">
                            <address class="m-t-5 m-b-5" style="margin-left: 10px !important;">
                                <p><b>ST_ID:</b></p>
                                <h5>{{stocktransfer.id}}</h5>
                                <p><b>Document Date:</b></p>
                                <h5>{{document_date| timeStamp}}</h5>
                                <p><b>Document Status:</b></p>
                                <h4><span class="right badge badge-secondary">{{stocktransfer.status}}</span></h4>
                                <p><b>Document Item Count: &nbsp;</b></p>
                                <h2><span class="right badge badge-warning">{{total_scanned_items}} Item(s)</span></h2>
                            </address>
                        </div>
                    </div>
                    &nbsp; &nbsp;
                    <div class="col-md-3" style="padding: 1% !important; background: cornsilk; border-radius: 30px !important;">
                        <div class="row">
                            <address class="m-t-5 m-b-5" style="margin-left: 10px !important;">
                                <h5>Origin: (Item Going From)</h5>
                                <strong class="text-inverse">{{ stocktransfer.request_origin_branch.branch }} - {{ stocktransfer.request_origin_branch.branch_code }}</strong
                                ><br />
                                {{ stocktransfer.request_origin_branch.address_line_1 }}<br />
                                {{ stocktransfer.request_origin_branch.address_line_2 }}<br />
                                {{ stocktransfer.request_origin_branch.address_line_3 }}<br />
                                <br />
                                {{ stocktransfer.request_origin_branch.city }} {{ stocktransfer.request_origin_branch.pincode }},
                                {{ stocktransfer.request_origin_branch.state }}, {{ stocktransfer.request_origin_branch.country }}
                                <br />
                                Phone: {{stocktransfer.request_origin_branch.phone}}<br>
                                Email: {{ stocktransfer.request_origin_branch.email }}
                            </address>
                        </div>
                    </div>
                    &nbsp; &nbsp;
<!--                    <div class="col-md-1"><br></div>-->
                    <div class="col-md-3" style="padding: 1% !important; background: cornsilk; border-radius: 30px !important;">
                        <div class="row">
                            <address class="m-t-5 m-b-5" style="margin-left: 10px !important;">
                                <h5>Destination: (Item Coming to)</h5>
                                <strong class="text-inverse">{{ stocktransfer.request_destination_branch.branch }} - {{ stocktransfer.request_destination_branch.branch_code }}</strong
                                ><br />
                                {{ stocktransfer.request_destination_branch.address_line_1 }}<br />
                                {{ stocktransfer.request_destination_branch.address_line_2 }}<br />
                                {{ stocktransfer.request_destination_branch.address_line_3 }}<br />
                                <br />
                                {{ stocktransfer.request_destination_branch.city }} {{ stocktransfer.request_destination_branch.pincode }},
                                {{ stocktransfer.request_destination_branch.state }}, {{ stocktransfer.request_destination_branch.country }}
                                <br />
                                Phone: {{stocktransfer.request_destination_branch.phone}}<br>
                                Email: {{ stocktransfer.request_destination_branch.email }}
                            </address>
                        </div>
                    </div>
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    <div class="col-md-2 justify-content-center" style="padding: 1% !important;">
                        <div class="row">

                                <button style="width:100% !important; margin-top: 10% !important; margin-bottom: 10% !important; background: orange !important; border-color: none !important;" class="btn" @click="scanAnyItemsPrompt()"><i class="fa fa-eye"></i> Scan Serial/IMEI</button>

                            <br>

                                <button style="width:100% !important; margin-top: 10% !important; margin-bottom: 10% !important;" class="btn btn-secondary" @click="scanItemsPrompt(item,index)"><i class="fa fa-print"></i> Print Transfer Request</button>

                            <br>

                                <button v-if="stocktransfer.status!='Pending Branch Manager Approval'" style="width:100% !important; margin-top: 10% !important; margin-bottom: 10% !important;" class="btn btn-success" @click="printTransferDocument"><i class="fa fa-print"></i> Print Transfer Document</button>

                        </div>
                    </div>
                </div>
            </div>
            <br><br>
            <br><br>
            <div class="col-md-12">
                <div class="row">
                    <div class="card card-danger card-outline" style="width:100% !important;">
                        <div class="card-body">
                            <div class="row">
                                <table class="table thead-dark table-striped" style="width: 100%">
                                    <colgroup>
                                        <col span="1" style="width: 10%;">
                                        <col span="1" style="width: 30%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 5%;">
                                        <col span="1" style="width: 10%;">
                                        <col span="1" style="width: 10%;">
                                        <col span="1" style="width: 10%;">
                                    </colgroup>
                                    <thead class="thead-dark">
                                    <th><b>Item Code</b></th>
                                    <th><b>Item Name</b></th>
                                    <th><b>Requested Quantity</b></th>
                                    <th><b>Approved Quantity</b></th>
                                    <th><b>Transferred Quantity</b></th>
                                    <th><b>Scanned Quantity</b></th>
                                    <th><b>Price</b></th>
                                    <th><b>Notes</b></th>
                                    <th><b>ZM Status</b></th>
                                    <th><i class="fa fa-cog"></i></th>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in stocktransfer.stock_transfer_request_details">
                                        <!--                                    <td>{{index}}</td>-->
                                        <td>
                                            <p>{{item.item_code}}</p>
                                            <p><button style="width:100% !important; background: orange !important; border-color: none !important;" class="btn" @click="scanItemsPrompt(item,index)"><i class="fa fa-eye"></i> Scan</button></p>
                                        </td>
                                        <td><p>{{item.item_name}}</p>
                                            <p>
                                            <div class="form-group">
                                                <label>Serial Numbers: </label>
                                                <span class="lead">
                                                <span v-if="stocktransfer.stock_transfer_request_details[index].stock_transfer_items.length>0" v-for="(sl, i) in item.stock_transfer_items" :key="i" class="badge badge-pill badge-dark">
                                                {{sl.transferred_imei}}
                                                <a style="cursor: pointer;" @click="removeSl(index,i)"><i class="fa fa-times" aria-hidden="true"></i></a>
                                                </span>
                                                </span>
                                            </div>
                                            </p>
                                            <!--                                        <div class="form-group">-->
                                            <!--                                            <label>Serial Numbers: </label>-->
                                            <!--                                            <span class="lead">-->
                                            <!--											<span v-if="stocktransfer.stock_transfer_request_details[index].stock_transfer_items.length<=item.transferred_quantity" v-for="(sl, i) in item.stock_transfer_items" :key="i" class="badge badge-pill badge-dark">-->
                                            <!--												{{sl.transferred_imei}}-->
                                            <!--												<a style="cursor: pointer;" @click="removeSl(index,i)"><i class="fa fa-times" aria-hidden="true"></i></a>-->
                                            <!--											</span>-->
                                            <!--										</span>-->
                                            <!--                                        </div>-->
                                            <!--                                        <div class="form-group">-->
                                            <!--                                            <input type="text" placeholder="Enter the serial number" v-model="sl_no">-->
                                            <!--                                        </div>-->
                                            <!--                                        <div class="form-group">-->
                                            <!--                                            <button class="btn btn-danger" @click="addWarehouseSerial(index, item.item_code)">Add</button>-->
                                            <!--                                        </div></td>-->
                                        <td style="padding-left: 3% !important;"><div class="row">
                                            <p>{{item.requested_quantity}}</p>
                                        </div></td>
                                        <td style="padding-left: 3% !important;"><div class="row">
                                            <p>{{item.approved_quantity}}</p>
                                        </div></td>
                                        <td><div class="row">
                                            <input style="width:80% !important;" class="form-control" type="number" v-model="item.transferred_quantity">
                                        </div></td>
                                        <td style="padding-left: 3% !important;"><div class="row">
                                            <b style="color: red !important;" v-if="item.stock_transfer_items?.length != item.transferred_quantity">{{item.stock_transfer_items?.length}}&nbsp;<span class="right badge badge-danger"><i class="fa fa-warning"></i></span></b>
                                            <b style="color: green !important;" v-if="item.stock_transfer_items?.length == item.transferred_quantity">{{item.stock_transfer_items?.length}}&nbsp;<span class="right badge badge-success"><i class="fa fa-check"></i></span></b>
                                        </div></td>
                                        <td><p>{{item.price}}</p></td>
                                        <td>{{item.notes}}</td>
                                        <td>{{item.status}}</td>
                                        <td>
                                            <button style="width:100% !important;" class="btn btn-success" @click="approveItemBM(index, 'APPROVED')" v-if="(item.status == 'CREATED'|| item.status == 'APPROVED') && branch != stocktransfer.destination_branch">Confirm</button>
                                            <br>
                                            <br>
                                            <button style="width:100% !important;" class="btn btn-danger" @click="approveItemBM(index, 'REMOVED')" v-if="(item.status == 'CREATED' || item.status == 'APPROVED') && branch != stocktransfer.destination_branch">Reject</button>
                                            <!--                                        <p><button @click="deleteTransferItem(index)" class="btn btn-danger"><i class="fa fa-trash"></i></button></p>-->
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br><br>
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-6" v-if="stocktransfer.accepted == true">
                        <span class="right badge badge-secondary">Notes:</span>
                        <input class="form-control" style="width:100% !important;" type="text" v-model="notes" placeholder="Enter notes" readonly>
                    </div>
                    <div class="col-md-6" v-if="stocktransfer.accepted != true">
                        <span class="right badge badge-secondary">Notes:</span>
                        <input class="form-control" style="width:100% !important;" type="text" v-model="notes" placeholder="Enter notes">
                    </div>
                    <br><br>
                    <br>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button style="width:100% !important;" class="btn btn-danger" @click="completeTransfer" v-if="stocktransfer.status == 'Pending Branch Manager Approval' && branch == stocktransfer.source_branch">Complete Stock Transfer</button>
                    </div>
                    <div class="col-md-12">
                        <button style="width:100% !important;" class="btn btn-danger" @click="completeTransfer" v-if="stocktransfer.status == 'Zonal Manager Approved' && branch == stocktransfer.source_branch">Complete Stock Transfer</button>
                    </div>
                    <div class="col-md-12">
                        <button style="width:100% !important;" class="btn btn-danger" @click="completeTransfer" v-if="stocktransfer.status == 'Branch Manager Approved' && branch == stocktransfer.source_branch">Complete Stock Transfer</button>
                    </div>
                    <div class="col-md-12">
                        <button style="width:100% !important;" class="btn btn-danger" @click="receivedTransfer" v-if="stocktransfer.status == 'In Transit' && branch == stocktransfer.destination_branch">Received Stock Transfer</button>
                    </div>
                    <div class="col-md-12">
                        <button style="width:100% !important;" class="btn btn-secondary" @click="ewayBillPrompt" v-if="stocktransfer.status == 'In Transit' && branch == stocktransfer.source_branch">Generate E Way Bill</button>
                    </div>
                </div>
            </div>
            <br><br><br><br><br><br><br>


            <br>






            <!--			<br>-->
            <!--			&lt;!&ndash; main row for all icons  &ndash;&gt;-->
            <!--			<div class="col-md-12">-->
            <!--				<div class="card card-primary card-outline">-->
            <!--					<div class="card-body">-->
            <!--						<div class="col-md-12" v-for="(item, index) in stocktransfer.stock_transfer_request_details">-->
            <!--							<div class="row">-->
            <!--								<div class="col-md-9">-->
            <!--									item, Required: {{item.required_quantity}}, Approved: {{item.approved_quantity}}, Transfer: {{item.transferred_quantity}}-->
            <!--									<br>-->
            <!--									<div class="form-group">-->
            <!--										<label>Serial Numbers: </label>-->
            <!--										<span class="lead">-->
            <!--											<span v-if="stocktransfer.stock_transfer_request_details[index].stock_transfer_items.length>0" v-for="(sl, i) in item.stock_transfer_items" :key="i" class="badge badge-pill badge-dark">-->
            <!--												{{sl.transferred_imei}}-->
            <!--												<a style="cursor: pointer;" @click="removeSl(index,i)"><i class="fa fa-times" aria-hidden="true"></i></a>-->
            <!--											</span>-->
            <!--										</span>-->
            <!--									</div>-->
            <!--								</div>-->
            <!--								<div class="col-md-3">-->
            <!--									<div class="row">-->
            <!--										<div class="col-md-3">-->
            <!--											<button class="btn btn-success fa fa-plus" @click="increment(index)"></button>-->
            <!--										</div>-->
            <!--										<div class="col-md-2">-->
            <!--											<input type="number" min="1" v-model="stocktransfer.stock_transfer_request_details[index].transferred_quantity">-->
            <!--										</div>-->
            <!--										<div class="col-md-3">-->
            <!--											<button class="btn btn-danger fa fa-minus" @click="decrement(index)"></button>-->
            <!--										</div>-->
            <!--									</div>-->
            <!--									<div class="col-md-6">-->
            <!--										<div class="form-group">-->
            <!--											<input type="text" placeholder="Enter the serial number" v-model="sl_no">-->
            <!--										</div>-->
            <!--										<div class="form-group">-->
            <!--											<button class="btn btn-danger" @click="addSerial(index, item.item_code)">Add</button>-->
            <!--										</div>-->
            <!--									</div>-->
            <!--									<button class="btn btn-success" @click="approveItemBM(index, 'APPROVED')" v-if="(item.status == 'CREATED'|| item.status == 'APPROVED') && branch != stocktransfer.source_branch">Approve</button>-->
            <!--									<button class="btn btn-danger" @click="approveItemBM(index, 'REMOVED')" v-if="(item.status == 'CREATED' || item.status == 'APPROVED') && branch != stocktransfer.source_branch">Reject</button>-->
            <!--								</div>-->
            <!--								<div class="col-md-2">-->
            <!--									<input type="text" v-model="stocktransfer.stock_transfer_request_details[index].Notes" placeholder="Enter notes">-->
            <!--								</div>-->
            <!--							</div>-->
            <!--						</div>-->
            <!--						<div class="col-md-6">-->
            <!--							<input type="text" v-model="notes" placeholder="Enter notes">-->
            <!--						</div>-->
            <!--						<div class="col-md-6">-->
            <!--							<button class="btn btn-danger" @click="completeTransfer" v-if="stocktransfer.status == 'Pending Branch Manager Approval' && branch != stocktransfer.source_branch">Complete Stock Transfer</button>-->
            <!--						</div>-->
            <!--						<div class="col-md-6">-->
            <!--							<button class="btn btn-danger" @click="receivedTransfer" v-if="stocktransfer.status == 'In Transit' && branch == stocktransfer.source_branch">Received Stock Transfer</button>-->
            <!--						</div>-->
            <!--						<div class="col-md-6">-->
            <!--							<button class="btn btn-danger" @click="ewayBillPrompt" v-if="stocktransfer.status == 'In Transit' && branch != stocktransfer.source_branch">Generate E Way Bill</button>-->
            <!--						</div>-->
            <!--					</div>-->
            <!--				</div>-->
            <!--			</div>-->
        </section>
        <!-- /.content -->

        <div class="modal" tabindex="-1" role="dialog" id="ewaymodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Generate E Way Bill</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Delivery Partner</label>
                            <v-select v-model="dp_id" :options="deliverypartners" label="name" :reduce="deliverypartners => deliverypartners.id" @input="getRest"></v-select>
                        </div>
                        <div class="form-group">
                            <label>Driver</label>
                            <select class="form-control" v-model="driver_id">
                                <option v-for="driver in drivers" :value="driver.id">{{driver.lead_profile.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Vehicle</label>
                            <select class="form-control" v-model="vehicle_id">
                                <option v-for="vehicle in vehicles" :value="vehicle.id">{{vehicle.make}}, {{vehicle.model}}, {{vehicle.color}}, {{vehicle.reg_no}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Transport Mode</label>
                            <select class="form-control" v-model="mode">
                                <option v-for="m in modes" :value="m.code">{{m.mode}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Distance</label>
                            <input type="number" v-model="distance" placeholder="Enter the distance" class="form-control" min="0" step=".01">
                        </div>
                        <div class="form-group">
                            <label>Date</label>
                            <input type="date" v-model="date" placeholder="Enter the date" class="form-control">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="eWayGenerate">Generate</button>
                        <button type="button" class="btn btn-primary" @click="eWayReGenerate">
                            Re Generate E-Way Bill
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade" role="dialog" aria-labelledby="scanItemsModal" aria-hidden="true" id="scanItemsModal">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="icantthinkofaname">Scan Items | Total Items scanned now: <b>{{item.stock_transfer_items?.length}}</b></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="overflow-auto" style="height: 400px">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <h3>{{item.item_code}}</h3>
                                    <h3>{{item.item_name}}</h3>
                                    <label>Serial Numbers: </label>
                                    <span class="lead">
											<span v-if="stocktransfer.stock_transfer_request_details[index].stock_transfer_items?.length<=item.transferred_quantity" v-for="(sl, i) in item.stock_transfer_items" :key="i" class="badge badge-pill badge-dark">
												{{sl.transferred_imei}}
												<a style="cursor: pointer;" @click="removeSl(index,i)"><i class="fa fa-times" aria-hidden="true"></i></a>
											</span>
										</span>
                                </div>
                                <div class="form-group" v-if="usertype == 'warehouse-manager'">
                                    <input type="text" style="width:100% !important;" class="form-control" id="sl_no" ref="sl_no" placeholder="Enter the serial number" v-model="sl_no" v-on:keyup.enter="addWarehouseSerial(index, item.item_code)">
                                </div>
                                <div class="form-group" v-if="usertype != 'warehouse-manager'">
                                    <input type="text" style="width:100% !important;" class="form-control" id="sl_no" ref="sl_no" placeholder="Enter the serial number" v-model="sl_no" v-on:keyup.enter="addSerial(index, item.item_code)">
                                </div>
                                <div class="form-group" v-if="usertype == 'warehouse-manager'">
                                    <button class="btn btn-danger" @click="addWarehouseSerial(index, item.item_code)">Add</button>
                                </div>
                                <div class="form-group" v-if="usertype != 'warehouse-manager'">
                                    <button class="btn btn-danger" @click="addSerial(index, item.item_code)">Add</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" role="dialog" aria-labelledby="scanItemsModal" aria-hidden="true" id="scanAnyItemsModal">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="icantthinkofaname">Scan All Items | Total Items scanned now: <b>{{scanned_items.length}}</b></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="overflow-auto" style="height: 400px">
                            <div class="col-md-12">
                                <table class="table table-striped table-hover">
                                    <thead class="thead-dark" style="position: sticky; top: 0">
                                    <tr>
                                        <th class="header" scope="col">Item Code</th>
                                        <th class="header" scope="col">Item Name</th>
                                        <th class="header" scope="col">Scanned Serial Number</th>
                                        <th class="header" scope="col">Status</th>
                                        <th class="header" scope="col">Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(i, index) in scanned_items">
                                        <th scope="row">{{ i.item_code }}</th>
                                        <th scope="row">{{ i.item_name }}</th>
                                        <td>{{ i.serial }}</td>
                                        <td><b style="color: yellow !important;" v-if="i.status==0"><span class="right badge badge-warning"><i class="fa fa-warning"></i></span></b>
                                            <b style="color: green !important;" v-if="i.status==1"><span class="right badge badge-success"><i class="fa fa-check"></i></span></b></td>
                                        <td>
                                            <b style="color: red !important;"><span @click="deleteScannedItem(index)" class="right badge badge-danger"><i class="fa fa-trash"></i></span></b>

                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group" v-if="usertype == 'warehouse-manager'">
                                        <input type="text" id="scanned_sl" ref="scanned_sl" style="width:100% !important;" class="form-control" v-model="scanned_sl" placeholder="Enter Serial" v-on:keyup.enter="addAnyWarehouseSerial()"  autofocus autofocus="autofocus">
                                        <br>
                                        <input type="text" id="list_of_sl" ref="list_of_sl" style="width:100% !important;" class="form-control" v-model="list_of_sl" placeholder="Paste copied column (spaces exempted)">
                                </div>
                                <div class="form-group" v-if="usertype != 'warehouse-manager'">
                                    <input type="text" id="scanned_sl" ref="scanned_sl" style="width:100% !important;" class="form-control" v-model="scanned_sl" placeholder="Enter Serial" v-on:keyup.enter="addAnySerial()"  autofocus autofocus="autofocus">
                                    <br>
                                    <input type="text" id="list_of_sl" ref="list_of_sl" style="width:100% !important;" class="form-control" v-model="list_of_sl" placeholder="Paste copied column (spaces exempted)"></div>
                                <div class="form-group" v-if="usertype == 'warehouse-manager'">
                                    <button class="btn btn-danger" v-if="status!='Checking'" @click="addAnyWarehouseSerial">Add</button>
                                </div>
                                <div class="form-group" v-if="usertype != 'warehouse-manager'">
                                    <button class="btn btn-danger" v-if="status!='Checking'" @click="addAnySerial()">Add</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>




        <loading :show="lshow" :label="llabel"> </loading>
        <!-- All VUE Parts end before this comment -->
    </div>
</template>

<script>
import loading from "vue-full-loading";

export default {
    mounted() {
        console.log('Component mounted.')
    },

    components: { loading },

    created(){
        this.backdoor++;
        this.branch = window.user.branch;
        this.getStockTransfer();
        this.usertype = window.user.user_type;
        this.getDeliveryPartners();
        this.getModes();
        this.focusInput();
        this.focusInputField();
    },

    computed: {
        total_scanned_items() {
            cache: false;
            return this.stocktransfer.stock_transfer_request_details?.reduce((total_scanned_items, item) => {
                let round_total =
                    parseFloat(total_scanned_items) + parseFloat(item.transferred_quantity);
                return round_total;
            }, 0);
        }
    },

    watch: {
        value() {
            this.backdoor++;
        },
    },

    data(){
        return{
            stocktransfer: {},
            usertype: '',
            notes: '',
            sl_no: '',
            scanned_sl:'',
            list_of_sl:'',
            scanned_items: [],
            itemcode:null,
            itemname:null,
            serial:null,
            deliverypartners: [],
            dp_id: '',
            verified_status:null,
            backdoor: 0,
            drivers: [],
            driver_id: '',
            vehicles: [],
            vehicle_id: '',
            distance: '',
            modes: [],
            mode: '',
            item:[],
            ewaybill: {},
            stock_transfer_request_details:[],
            branch: '',
            date: '',
            document_date:'',
            lshow: false,
            llabel: "",
            search_status:'',
            status:'',
        }
    },

    methods: {
        getStockTransfer(){
            axios.post("/api/getStockTransfer", {id: this.$route.params.id})
                .then(response => {
                    this.stocktransfer = response.data;
                    this.stock_transfer_request_details = response.data.stock_transfer_request_details;
                    this.document_date=this.stocktransfer.created_at;
                })
        },

        getDeliveryPartners(){
            axios.post("/api/getAllDeliveryPartners")
                .then(response => {
                    this.deliverypartners = response.data;
                })
        },

        scanItemsPrompt(item,index){
            this.focusInput();
            this.focusInputField();
            this.index=index;
            this.item=item;
            console.log(item.item_code);
            // this.allotment_id = allotment.id;
            // this.title = "A "+allotment.gift_rule.assigned_gift+" is given to "+allotment.gift_registration.first_name+" "+allotment.gift_registration.last_name+", "+allotment.phone;
            $("#scanItemsModal").modal("show");
            this.focusInput();
            this.focusInputField();
        },

        scanAnyItemsPrompt(item,index){
            this.focusInput();
            this.focusInputField();
            // this.allotment_id = allotment.id;
            // this.title = "A "+allotment.gift_rule.assigned_gift+" is given to "+allotment.gift_registration.first_name+" "+allotment.gift_registration.last_name+", "+allotment.phone;
            $("#scanAnyItemsModal").modal("show");
            this.focusInput();
            this.focusInputField();
        },

        addScannedItemPrompt() {
            $("#addScannedItemModal").modal("show");
        },

        focusInput() {
            // this.$refs.scannedSerial.$el.focus();
            $('#scanAnyItemsModal').on('shown.bs.modal', function () {
                $('#scanned_sl').focus()
            })
        },

        focusInputField() {
            // this.$refs.scannedSerial.$el.focus();
            $('#scanned_sl').focus()
        },

        getRest(){
            axios.post("/api/getPartnerDrivers", {dp: this.dp_id, paginate: false})
                .then(response => {
                    this.drivers = response.data;
                })
            axios.post("/api/getPartnerVehicles", {dp: this.dp_id, paginate: false})
                .then(response => {
                    this.vehicles = response.data;
                })
        },

        getModes(){
            axios.post("/api/getTMS")
                .then(response => {
                    this.modes = response.data;
                })
        },

        increment(index){
            if(this.usertype == 'zonal-manager')
                this.stocktransfer.stock_transfer_request_details[index].approved_quantity = parseInt(this.stocktransfer.stock_transfer_request_details[index].approved_quantity)+parseInt(1);
            this.stocktransfer.stock_transfer_request_details[index].transferred_quantity = parseInt(this.stocktransfer.stock_transfer_request_details[index].approved_quantity)+parseInt(1);
        },

        decrement(index){
            if(this.usertype == 'zonal-manager')
                this.stocktransfer.stock_transfer_request_details[index].approved_quantity = parseInt(this.stocktransfer.stock_transfer_request_details[index].approved_quantity)-parseInt(1);
            this.stocktransfer.stock_transfer_request_details[index].transferred_quantity = parseInt(this.stocktransfer.stock_transfer_request_details[index].approved_quantity)-parseInt(1);
        },

        addPrompt(){
            $("#searchModal").modal("show");
        },

        approveItemZM(index, status){
            this.stocktransfer.stock_transfer_request_details[index].status = status;
            if(status=='REMOVED')
            this.stocktransfer.stock_transfer_request_details[index].transferred_quantity = '0';
        },

        approveItemBM(index, status){
            this.stocktransfer.stock_transfer_request_details[index].status = status;
            if(status=='REMOVED')
                this.stocktransfer.stock_transfer_request_details[index].transferred_quantity = '0';
        },

        approveTransfer(){
            axios.post("/api/stockTransferAccept", {id: this.stocktransfer.id, items: this.stocktransfer.stock_transfer_request_details, notes: this.notes})
                .then(() => {
                    toast.fire({
                        icon: 'success',
                        title: 'Request Made'
                    });
                })
        },

        completeTransfer(){
            this.search_status = "Completing...";
            this.lshow = true;
            this.llabel = this.search_status;
            axios.post("/api/stockTransferComplete", {id: this.stocktransfer.id, items: this.stocktransfer.stock_transfer_request_details, notes: this.notes})
                .then(response => {
                    if(response.data == 500){
                        toast.fire({
                            icon: 'error',
                            title: 'Failed. Check Quantities and Sl. Nos'
                        });
                        this.search_status = "Something Happened...";
                        this.lshow = false;
                        this.llabel = this.search_status;
                    }
                    else if(response.data.p1_sap_status == 1){
                        toast.fire({
                            icon: 'success',
                            title: 'Stock Transfer Complete'
                        });
                        this.search_status = "Success";
                        this.lshow = false;
                        this.llabel = this.search_status;
                        this.getStockTransfer();
                    }
                    else{
                        this.search_status = "Failed";
                        this.lshow = false;
                        this.llabel = this.search_status;
                        toast.fire({
                            title: 'Failed!',
                            icon: 'error'
                        })
                    }
                })
            this.search_status = "Complete";
            this.lshow = false;
            this.llabel = this.search_status;
        },

        addSerial(index, item_code){
            axios.post("/api/verifySerialNo", {code: item_code, sl_no: this.sl_no, warehouse: this.stocktransfer.destination_warehouse})
                .then(response =>{
                    if(response.data == 1){
                        if (this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.some(item => item.transferred_imei == this.sl_no)) {
                            console.log((this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.some(item => item.transferred_imei === this.sl_no)));
                            console.log('Duplicate');
                            toast.fire({
                                title: 'Duplicate Sl. No.',
                                icon: 'error'
                            });
                        }
                        else{
                            console.log((this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.some(item => item.transferred_imei == this.sl_no)));
                            if(this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.length<this.stock_transfer_request_details[index].transferred_quantity){
                                this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.push({transferred_imei: this.sl_no});
                                this.sl_no = '';
                                this.focusInput();
                                this.focusInputField();
                            }
                            else
                            {
                                this.sl_no = '';
                                toast.fire({
                                    title: 'Quantity Mismatch',
                                    icon: 'error'
                                });
                            }
                    }
                    }
                    else
                    {
                        this.sl_no = '';
                        toast.fire({
                            title: 'Wrong Sl. No.',
                            icon: 'error'
                        });
                    }
                });
            this.focusInput();
            this.focusInputField();
        },

        addWarehouseSerial(index, item_code){
            axios.post("/api/verifySerialNo", {code: item_code, sl_no: this.sl_no, warehouse: this.stocktransfer.source_warehouse})
                .then(response =>{
                    if(response.data == 1){
                        if (this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.some(item => item.transferred_imei === this.sl_no)) {
                            console.log((this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.some(item => item.transferred_imei === this.sl_no)));
                            console.log('Duplicate');
                            toast.fire({
                                title: 'Duplicate Sl. No.',
                                icon: 'error'
                            });
                        }
                        else{
                            console.log((this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.some(item => item.transferred_imei === this.sl_no)));
                            if(this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.length<this.stock_transfer_request_details[index].transferred_quantity){
                                this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.push({transferred_imei: this.sl_no});
                                this.sl_no = '';
                                this.focusInput();
                                this.focusInputField();
                            }
                            else {
                                this.sl_no = '';
                                toast.fire({
                                    title: 'Quantity Mismatch',
                                    icon: 'error'
                                });
                            }
                        }
                    }
                    else {
                        this.sl_no = '';
                        toast.fire({
                            title: 'Wrong Sl. No.',
                            icon: 'error'
                        });
                    }
                });
            this.focusInput();
            this.focusInputField();
        },

        addAnySerial(){
            this.focusInput();
            this.search_status = "Checking item(s)...";
            this.lshow = true;
            this.llabel = this.search_status;
            if(this.scanned_sl!='' && this.scanned_sl!=null) {
                if (this.list_of_sl == '' && this.scanned_sl!=null) {
                    this.search_status = "Checking item(s)...";
                    this.lshow = true;
                    this.llabel = this.search_status;
                    if (window.user.user_type != 'warehouse-manager') {
                        axios.post("/api/verifySerialNoDetailed", {
                            code: null,
                            sl_no: this.scanned_sl,
                            warehouse: this.stocktransfer.destination_warehouse
                        })
                            .then(response => {
                                if (response.data.status == 1) {
                                    this.verified_status = 1;
                                    this.itemcode = response.data.data.ItemCode;
                                    this.itemname = response.data.data.ItemName;
                                    this.serial = response.data.data.SerialNumber;
                                    if (this.scanned_items.some(item => item.serial === this.serial)) {
                                        console.log((this.scanned_items.some(item => item.serial === this.serial)));
                                        console.log('Duplicate');
                                        toast.fire({
                                            title: 'Duplicate Sl. No.',
                                            icon: 'error'
                                        });
                                    }
                                    else{
                                        let itemIndex = this.stocktransfer.stock_transfer_request_details.findIndex(item => item.item_code === this.itemcode);

                                        if(itemIndex != -1) {
                                            // The item exists in stock_transfer_request_details array, and its index is itemIndex
                                            // You can use itemIndex as needed
                                            if(this.stocktransfer.stock_transfer_request_details[itemIndex].stock_transfer_items.length<this.stock_transfer_request_details[itemIndex].transferred_quantity) {
                                                this.stocktransfer.stock_transfer_request_details[itemIndex].stock_transfer_items.push({transferred_imei: this.serial});
                                                this.sl_no = '';
                                                this.scanned_items.push({
                                                    item_code: this.itemcode,
                                                    item_name: this.itemname,
                                                    serial: this.serial,
                                                    status: 1
                                                });
                                            }
                                        }
                                        else{
                                            console.log('ItemCode not in document.');
                                            this.scanned_items.push({
                                                item_code: this.itemcode,
                                                item_name: this.itemname,
                                                serial: this.serial,
                                                status: 0
                                            });
                                        }

                                        console.log(itemIndex);
                                    }
                                    this.search_status = "Done";
                                    this.lshow = false;
                                    this.llabel = this.search_status;
                                    // console.log(this.scanned_items.some(item => item.serial != this.serial));
                                    console.log('WM Item Added');
                                }
                                else
                                {
                                    this.search_status = "Done";
                                    this.lshow = false;
                                    this.llabel = this.search_status;
                                    this.list_of_sl='';
                                    this.scanned_sl='';
                                    toast.fire({
                                        title: 'Wrong Sl. No.',
                                        icon: 'error'
                                    });
                                }
                            });

                    }

                }
            }
            if (this.list_of_sl != '') {
                this.status='Checking';
                this.search_status = "Checking item(s)...";
                this.lshow = true;
                this.llabel = this.search_status;
                let wordsArray = this.list_of_sl.split(" ");
                toast.fire({
                    title: 'Checking. Please wait',
                    icon: 'success'
                });

                // Set initial values for search_status and lshow
                this.search_status = "Checking...";
                this.lshow = true;
                this.llabel = this.search_status;
// Loop through the wordsArray and push each word into the individualWordsArray
                for (let i = 0; i < wordsArray.length; i++) {
                    // codes_buffer.push([wordsArray[i]]);
                    // if(parseFloat(this.total_scanned_items)<=parseInt(parseInt(draft_item.order_quantity)-parseInt(draft_item.fulfilled_quantity)))
                    // {
                    if (window.user.user_type != 'warehouse-manager') {
                        this.search_status = "Checking...";
                        this.lshow = true;
                        this.llabel = this.search_status;
                        axios.post("/api/verifySerialNoDetailed", {
                            code: null,
                            sl_no: wordsArray[i],
                            warehouse: this.stocktransfer.destination_warehouse
                        })
                            .then(response =>{
                                if (response.data.status == 1) {
                                    this.verified_status = 1;
                                    this.itemcode = response.data.data.ItemCode;
                                    this.itemname = response.data.data.ItemName;
                                    this.serial = response.data.data.SerialNumber;
                                    if (this.scanned_items.some(item => item.serial === this.serial)) {
                                        console.log((this.scanned_items.some(item => item.serial === this.serial)));
                                        console.log('Duplicate');
                                        toast.fire({
                                            title: 'Duplicate Sl. No.',
                                            icon: 'error'
                                        });
                                        this.list_of_sl='';
                                        this.scanned_sl='';
                                    }
                                    else{
                                        let itemIndex = this.stocktransfer.stock_transfer_request_details.findIndex(item => item.item_code === this.itemcode);

                                        if(itemIndex != -1) {
                                            toast.fire({
                                                title: 'Checking',
                                                icon: 'success'
                                            });
                                            // The item exists in stock_transfer_request_details array, and its index is itemIndex
                                            // You can use itemIndex as needed
                                            if(this.stocktransfer.stock_transfer_request_details[itemIndex].stock_transfer_items.length<this.stock_transfer_request_details[itemIndex].transferred_quantity) {
                                                this.stocktransfer.stock_transfer_request_details[itemIndex].stock_transfer_items.push({transferred_imei: this.serial});
                                                this.sl_no = '';
                                                this.scanned_items.push({
                                                    item_code: this.itemcode,
                                                    item_name: this.itemname,
                                                    serial: this.serial,
                                                    status: 1
                                                });
                                            }
                                        }
                                        else{
                                            console.log('ItemCode not in document.');
                                            this.scanned_items.push({
                                                item_code: this.itemcode,
                                                item_name: this.itemname,
                                                serial: this.serial,
                                                status: 0
                                            });
                                        }

                                        console.log(itemIndex);
                                    }
                                    // console.log(this.scanned_items.some(item => item.serial != this.serial));
                                    console.log('Store Item Added');
                                }
                                else
                                {
                                    toast.fire({
                                        title: 'Wrong Sl. No.',
                                        icon: 'error'
                                    });
                                    this.list_of_sl='';
                                    this.scanned_sl='';
                                }
                            });

                    }
                    toast.fire({
                        title: 'Checked and Added',
                        icon: 'success'
                    });
                    this.search_status = "Done";
                    this.lshow = false;
                    this.llabel = this.search_status;
                }
                this.status='Completed';
                this.list_of_sl='';
                this.scanned_sl='';
                this.search_status = "Done";
                this.lshow = false;
                this.llabel = this.search_status;

            }

            this.focusInput();
            this.focusInputField();
        },

        addAnyWarehouseSerial(){
            this.focusInput();
            console.log('Warehouse user online');
            this.search_status = "Checking item(s)...";
            this.lshow = true;
            this.llabel = this.search_status;
            if(this.scanned_sl!='' && this.scanned_sl!=null) {

                    if (window.user.user_type == 'warehouse-manager') {
                        axios.post("/api/verifySerialNoDetailed", {
                            code: null,
                            sl_no: this.scanned_sl,
                            warehouse: this.stocktransfer.source_warehouse
                        })
                            .then(response => {
                                if (response.data.status == 1) {
                                    this.verified_status = 1;
                                    this.itemcode = response.data.data.ItemCode;
                                    this.itemname = response.data.data.ItemName;
                                    this.serial = response.data.data.SerialNumber;
                                    if (this.scanned_items.some(item => item.serial === this.serial)) {
                                        console.log((this.scanned_items.some(item => item.serial === this.serial)));
                                        console.log('Duplicate');
                                        toast.fire({
                                            title: 'Duplicate Sl. No.',
                                            icon: 'error'
                                        });
                                    }
                                    else{
                                        let itemIndex = this.stocktransfer.stock_transfer_request_details.findIndex(item => item.item_code === this.itemcode);
                                        if(itemIndex != -1) {
                                            // The item exists in stock_transfer_request_details array, and its index is itemIndex
                                            // You can use itemIndex as needed
                                            if(this.stocktransfer.stock_transfer_request_details[itemIndex].stock_transfer_items.length<this.stock_transfer_request_details[itemIndex].transferred_quantity) {
                                                this.stocktransfer.stock_transfer_request_details[itemIndex].stock_transfer_items.push({transferred_imei: this.serial});
                                                this.sl_no = '';
                                                this.scanned_sl = '';
                                                this.scanned_items.push({
                                                    item_code: this.itemcode,
                                                    item_name: this.itemname,
                                                    serial: this.serial,
                                                    status: 1
                                                });
                                            }
                                        }
                                        else{
                                            console.log('ItemCode not in document.');
                                            this.scanned_items.push({
                                                item_code: this.itemcode,
                                                item_name: this.itemname,
                                                serial: this.serial,
                                                status: 0
                                            });
                                        }

                                        console.log(itemIndex);
                                    }
                                    this.search_status = "Done";
                                    this.lshow = false;
                                    this.llabel = this.search_status;
                                    this.sl_no = '';
                                    this.scanned_sl = '';
                                    // console.log(this.scanned_items.some(item => item.serial != this.serial));
                                    console.log('WM Item Added');
                                }
                                else
                                {
                                    this.search_status = "Done";
                                    this.lshow = false;
                                    this.llabel = this.search_status;
                                    this.list_of_sl='';
                                    this.scanned_sl='';
                                    toast.fire({
                                        title: 'Wrong Sl. No.',
                                        icon: 'error'
                                    });
                                }
                            });

                    }

            }
            if (this.list_of_sl != '' && this.scanned_sl!=null) {
                this.status='Checking';
                let wordsArray = this.list_of_sl.split(" ");
                toast.fire({
                    title: 'Checking. Please wait',
                    icon: 'success'
                });

                // Set initial values for search_status and lshow
                // this.search_status = "Checking...";
                // this.lshow = true;
                // this.llabel = this.search_status;
// Loop through the wordsArray and push each word into the individualWordsArray
                    for (let i = 0; i < wordsArray.length; i++) {
                        // codes_buffer.push([wordsArray[i]]);
                        // if(parseFloat(this.total_scanned_items)<=parseInt(parseInt(draft_item.order_quantity)-parseInt(draft_item.fulfilled_quantity)))
                        // {
                        if (window.user.user_type == 'warehouse-manager') {
                            axios.post("/api/verifySerialNoDetailed", {
                                code: null,
                                sl_no: wordsArray[i],
                                warehouse: this.stocktransfer.source_warehouse
                            })
                                .then(response =>{
                                if (response.data.status == 1) {
                                    this.verified_status = 1;
                                    this.itemcode = response.data.data.ItemCode;
                                    this.itemname = response.data.data.ItemName;
                                    this.serial = response.data.data.SerialNumber;
                                    if (this.scanned_items.some(item => item.serial === this.serial)) {
                                        console.log((this.scanned_items.some(item => item.serial === this.serial)));
                                        console.log('Duplicate');
                                        toast.fire({
                                            title: 'Duplicate Sl. No.',
                                            icon: 'error'
                                        });
                                    }
                                    else{
                                        let itemIndex = this.stocktransfer.stock_transfer_request_details.findIndex(item => item.item_code === this.itemcode);

                                        if(itemIndex != -1) {
                                            // this.search_status = "Checking Item(s)...";
                                            // this.lshow = true;
                                            // this.llabel = this.search_status;
                                            // The item exists in stock_transfer_request_details array, and its index is itemIndex
                                            // You can use itemIndex as needed
                                            if(this.stocktransfer.stock_transfer_request_details[itemIndex].stock_transfer_items.length<this.stock_transfer_request_details[itemIndex].transferred_quantity) {
                                                this.stocktransfer.stock_transfer_request_details[itemIndex].stock_transfer_items.push({transferred_imei: this.serial});
                                                this.sl_no = '';
                                                this.scanned_sl = '';
                                                this.scanned_items.push({
                                                    item_code: this.itemcode,
                                                    item_name: this.itemname,
                                                    serial: this.serial,
                                                    status: 1
                                                });
                                            }
                                        }
                                        else{
                                            console.log('ItemCode not in document.');
                                            this.scanned_items.push({
                                                item_code: this.itemcode,
                                                item_name: this.itemname,
                                                serial: this.serial,
                                                status: 0
                                            });
                                        }

                                        console.log(itemIndex);
                                    }
                                    // console.log(this.scanned_items.some(item => item.serial != this.serial));
                                    console.log('WM Item Added');
                                }
                                else
                                {
                                    toast.fire({
                                        title: 'Wrong Sl. No.',
                                        icon: 'error'
                                    });
                                    this.list_of_sl='';
                                    this.scanned_sl='';
                                }
                            });

                        }
                        toast.fire({
                            title: 'Checked and Added',
                            icon: 'success'
                        });
                        this.search_status = "Done";
                        this.lshow = false;
                        this.llabel = this.search_status;
                    }
                toast.fire({
                    title: 'Finishing up',
                    icon: 'success'
                });
                    this.status='Completed';
                this.list_of_sl='';
                this.scanned_sl='';
                this.search_status = "Done";
                this.lshow = false;
                this.llabel = this.search_status;
            }
            toast.fire({
                title: 'Done',
                icon: 'success'
            });
            this.search_status = "Done";
            this.lshow = false;
            this.llabel = this.search_status;
            this.focusInput();
            this.focusInputField();
        },

        deleteScannedItem(index) {
            this.scanned_items.splice(index, 1);
        },

        removeSl(index, i){
            this.removeFully(this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items[i]);
            this.stocktransfer.stock_transfer_request_details[index].stock_transfer_items.splice(i, 1);
            toast.fire({
                icon: 'success',
                title: 'SerialNumber Removed'
            });
        },

        removeFully(item){
            console.log(item.id);
            axios.post("/api/removeStockTransferSerial", {id: item.id})
                .then(() => {
                    toast.fire({
                        icon: 'success',
                        title: 'Passed removal notification to ERP RecordKeeper System'
                    });
                })
        },

        receivedTransfer(){
            axios.post("/api/stockTransferReceived", {id: this.stocktransfer.id, items: this.stocktransfer.stock_transfer_request_details, notes: this.notes})
                .then(() => {
                    toast.fire({
                        icon: 'success',
                        title: 'Request Received'
                    });
                })
        },

        ewayBillPrompt(){
            $("#ewaymodal").modal("show");
        },

        eWayGenerate(){
            var partner = this.deliverypartners.find(d => d.id === this.dp_id);
            var vehicle = this.vehicles.find(d => d.id === this.vehicle_id);
            axios.post("/api/generateEWayBillST", {
                st_id: this.stocktransfer.first_key,
                to: this.stocktransfer.source_branch,
                vehicle_id: this.vehicle_id,
                dp_id: this.dp_id,
                driver_id: this.driver_id,
                delivery_distance: this.distance,
                vehicle_reg_no: vehicle.reg_no,
                dp_tax_id: partner.tax_id,
                dp_name: partner.name,
                mode: this.mode
            })
                .then(response => {
                    this.ewaybill = response.data;
                })
                .catch(() => {
                    toast.fire({
                        icon: 'error',
                        title: 'Failed! Contact System Administrator'
                    });
                })
        },
        printTransferDocument(){
            window.alert('Document Print Layout Locked by Admin');
        },

        eWayReGenerate() {
            var partner = this.deliverypartners.find((d) => d.id === this.dp_id);
            var vehicle = this.vehicles.find((d) => d.id === this.vehicle_id);
            axios.post("/api/reGenerateEWayBillST", {
                st_id: this.stocktransfer.first_key,
                to: this.stocktransfer.source_branch,
                vehicle_id: this.vehicle_id,
                dp_id: this.dp_id,
                driver_id: this.driver_id,
                delivery_distance: this.distance,
                vehicle_reg_no: vehicle.reg_no,
                dp_tax_id: partner.tax_id,
                dp_name: partner.name,
                mode: this.mode,
                date: this.date
            })
                .then((response) => {
                    this.ewaybill = response.data;
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed! Contact System Administrator",
                    });
                });
        }
    }
}
</script>
